import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { MasterBlock } from '../MasterBlock';
import { SimpleBar } from '../SimpleBar';
import { Table } from '../Table';
import { Row } from '../Table/row';
import { noEditableStyle } from '../styles';
import PropTypes from '../../../utils/propTypes';

const MashWidgetRow = ({ total, control, element }) => {
  const intl = useIntl();
  return (
    <Row
      cells={[
        {
          value: `${intl.formatMessage({ id: 'elements.' + element })}`,
          style: { backgroundColor: '#e6e6e6' },
        },
        { value: total, style: noEditableStyle },
        { value: control, style: noEditableStyle },
        {
          html: <SimpleBar values={[total, control]} />,
          style: { backgroundColor: '#FFFFFF', border: '0px' },
        },
      ]}
    />
  );
};

MashWidgetRow.propTypes = {
  total: PropTypes.number.isRequired,
  control: PropTypes.number.isRequired,
  element: PropTypes.string.isRequired,
};

const MashWidget = ({ title, values, elements }) => {
  const intl = useIntl();
  const [total, setTotal] = useState([0, 0]);

  useEffect(() => {
    setTotal([
      elements.reduce(
        (accumulator, element) => accumulator + values.mash_total[element],
        0,
      ),
      elements.reduce(
        (accumulator, element) => accumulator + values.mash_control[element],
        0,
      ),
    ]);
  }, [values.mash_total, elements, values.mash_control]);

  return (
    <MasterBlock title={title} color="#B0B0B0">
      <div className="card-wrapper-table">
        <Table style={{ paddingRight: '0px' }}>
          <Row
            cells={[
              {
                value: '',
                style: { backgroundColor: '#FFFFFF', width: '22%' },
              },
              {
                value: `${intl.formatMessage({ id: 'total' })}`,
                style: { backgroundColor: '#e6e6e6', width: '8%' },
              },
              {
                value: `${intl.formatMessage({ id: 'controlled' })}`,
                style: { backgroundColor: '#e6e6e6', width: '10%' },
              },
              {
                value: '',
                style: {
                  backgroundColor: '#FFFFFF',
                  width: '55%',
                  border: '0px',
                },
              },
            ]}
          />
          {elements.map((element) => (
            <MashWidgetRow
              key={`MashWidgetRow-${element}`}
              total={values.mash_total[element]}
              control={values.mash_control[element]}
              element={element}
            />
          ))}
          <Row
            cells={[
              {
                value: `${intl.formatMessage({ id: 'total.mashes' })}`,
                style: { backgroundColor: '#e6e6e6' },
              },
              { value: total[0], style: noEditableStyle },
              { value: total[1], style: noEditableStyle },
              {
                html: <SimpleBar values={total} />,
                style: { backgroundColor: '#FFFFFF', border: '0px' },
              },
            ]}
          />
        </Table>
      </div>
    </MasterBlock>
  );
};

MashWidget.propTypes = {
  title: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  elements: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default MashWidget;
